import { Outlet } from "react-router-dom";
import { Navbar } from "./navbar";
import { Footer } from "./footer";
import { RouteSeo } from "./route-seo";

const RootLayout = () => {
    return (
        <>
            <RouteSeo />
            <Navbar />
            <div className="pt-24">
                <Outlet />
            </div>
            <Footer />
        </>
    );
};

export default RootLayout;
